import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSessionMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_SESSION_MESSAGE);
        this.id = 0;
        this.name = '';
        /**
         * Current session start of date on server. (with timeOffset)
         */
        this.serverBeginDayDate = null;
        this.periods = null;
        this.holidays = null;
        this.currentPeriodId = 0;
        this.blockTrading = false;
        this.firstDayOfWeek = 1;
    }
}
